import type { GameManifest } from "../../contracts/game";

export const game2048Manifest: GameManifest = {
  id: "2048",
  title: "2048",
  version: "1.0.1",
  status: "playable",
  coverAsset: "/covers/2048-v2.svg",
  catalogOrder: 4,
  preferredAspectRatio: 1,
  supportsCpu: false,
  load: () => import("./index"),
};
